export default __webpack_public_path__ + "static/WW-pinched-icon-84e9cc338529c5f508f43cb7eaf2d705.svg";